import axios from "axios";

import { normalizeBaseUrl } from "../utils/url";

const SERVER_URL = normalizeBaseUrl(process.env.REACT_APP_SERVER_URL);

export const api = axios.create({
  baseURL: SERVER_URL,
  headers: {
    "Content-Type": "application/json",
  },
});